module.exports = __webpack_public_path__ + "static/img/15a.cf18285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/15a.jpg
// module id = x7ii
// module chunks = 0